export default __webpack_public_path__ + "static/media/S2F_Logo_Icon.6cad6ab8.svg";